export class Constants {

  static HttpServer = class {

    public static baseURL: string = "";
    public static baseApiURL: string = "../../pmc/appjson";
    public static baseCmsURL: string = "/aembd/content/bancadigitale/findomestic";
    /* public static baseURL: string = 'https://b2ctest.ecredit.it';
    public static baseApiURL: string = 'https://b2ctest.ecredit.it/clienti/pmc/appjson';
    public static baseCmsURL: string = 'https://b2ctest.ecredit.it/aempubtest/content/areaclienti/findomestic'; */
    //b2ctest.ecredit.it/aembd/content/bancadigitale/findomestic/private/prodotti/conto-deposito/lista-movimenti.contents.json

    public static baseProdURL: string = 'https://secure.findomestic.it';
    public static baseResTimeOut: number = 20;

    public static codeReturn = {
      ServiceOk: "0",
      SessionExpired: "11",
      GenericError: "12",
      OtpMandatory: "13",
      ShowAllErrorMessage: "14"
    };

    public static API = {};

    public static CMS_PAGES = {
      null:".json"
    }

  }

  public static ROUTE_HOME_PAGE = "/private-area";
  public static ROUTE_APP = "/customer-area/";

}